// @flow


type AppConfigType = {
    BASE_URL: string,
    USE_CROSSDOMAIN: boolean,
    HUD_DEFAULT_LINE: number,
    HUD_DEFAULT_OFFSET: number,
    HUD_DEFAULT_STEP: number,
    ANGLE_COUNT: number,
    DEFAULT_LINE_COUNT: number,
    DEFAULT_HUD_POINTS: number,
    DEFAULT_ADD_POINTS: number,
    DEFAULT_ADAS_AREAS: number,
    // Default tolerances: [1k, 2k, 1s, 2s, 1l, 2l, 1h, 2h]
    DEFAULT_TOLERANCES: number[]
};


const AppConfig: AppConfigType = {
    // Base URL to where UI should make REST requests
    BASE_URL: (process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : 'KlpmsData.svc'),
    // Set true if API requests are cross-domain
    USE_CROSSDOMAIN: false,
    // Number of HUD points
    // Default HUD points line (first line is 1)
    HUD_DEFAULT_LINE: 1,
    // Default fist HUD point offset from the edge (mm)
    HUD_DEFAULT_OFFSET: 300,
    // Default step between HUD points (mm)
    HUD_DEFAULT_STEP: 50,
    // How many angles to display on the wagons screen
    ANGLE_COUNT: 1,
    // Default line count
    DEFAULT_LINE_COUNT: 3,
    // Default HUD points
    DEFAULT_HUD_POINTS: 0,
    /// Default additional points
    DEFAULT_ADD_POINTS: 0,
    // Default ADAS areas count
    DEFAULT_ADAS_AREAS: 0,
    // Default tolerances: [1k, 2k, 1s, 2s, 1l, 2l, 1h, 2h]
    DEFAULT_TOLERANCES: [1.7, 2.2, 1.2, 1.7, 1.5, 2.1, 1.5, 1.5]
};


export default AppConfig;
